import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-ad007852"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "ant-variant-selector__label"
}
const _hoisted_2 = {
  key: 0,
  class: "ant-variant-selector__value"
}
const _hoisted_3 = { class: "ant-variant-selector__options" }
const _hoisted_4 = ["disabled", "title", "onClick"]
const _hoisted_5 = { key: 1 }

import { computed } from "vue";
import type { VariantGroup, VariantOption } from "./types";

type VariantValue = Record<string, string | number | null | undefined>;

interface Props {
  modelValue?: VariantValue;
  /** Nhóm biến thể: size, color, material... */
  groups?: VariantGroup[];
  disabled?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductVariantSelector',
  props: {
    modelValue: { default: () => ({}) },
    groups: { default: () => [] },
    disabled: { type: Boolean, default: false }
  },
  emits: ["update:modelValue", "change"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const normalizedGroups = computed(() => props.groups || []);

const innerValue = computed({
  get: () => props.modelValue || {},
  set: (val: VariantValue) => emit("update:modelValue", val),
});

const selectedLabels = computed(() => {
  const result: Record<string, string> = {};
  for (const group of normalizedGroups.value) {
    const selected = group.options.find(
      (opt) => String(opt.value) === String(innerValue.value[group.key])
    );
    if (selected) result[group.key] = selected.label;
  }
  return result;
});

const selectOption = (key: string, option: VariantOption) => {
  if (props.disabled || option.disabled) return;
  const next = { ...innerValue.value, [key]: option.value };
  emit("update:modelValue", next);
  emit("change", next, { key, option });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["ant-variant-selector", { 'ant-variant-selector--disabled': _ctx.disabled }])
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(normalizedGroups.value, (group) => {
      return (_openBlock(), _createElementBlock("div", {
        key: group.key,
        class: "ant-variant-selector__group"
      }, [
        (group.label)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createTextVNode(_toDisplayString(group.label) + " ", 1),
              (selectedLabels.value[group.key])
                ? (_openBlock(), _createElementBlock("span", _hoisted_2, " : " + _toDisplayString(selectedLabels.value[group.key]), 1))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.options, (opt) => {
            return (_openBlock(), _createElementBlock("button", {
              key: String(opt.value),
              type: "button",
              class: _normalizeClass(["ant-variant-selector__option", {
            'is-active': String(innerValue.value[group.key]) === String(opt.value),
            'is-disabled': opt.disabled || _ctx.disabled,
            'is-color': !!opt.color,
          }]),
              disabled: opt.disabled || _ctx.disabled,
              title: opt.label,
              style: _normalizeStyle(opt.color ? { '--variant-color': opt.color } : undefined),
              onClick: ($event: any) => (selectOption(group.key, opt))
            }, [
              (opt.color)
                ? (_openBlock(), _createElementBlock("span", {
                    key: 0,
                    class: "ant-variant-selector__swatch",
                    style: _normalizeStyle({ background: opt.color })
                  }, null, 4))
                : (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(opt.label), 1))
            ], 14, _hoisted_4))
          }), 128))
        ])
      ]))
    }), 128))
  ], 2))
}
}

})